import { useEffect, useState } from 'react';
import { Braces, Copy, Check, X } from 'lucide-react';
import { useClipboard } from '../hooks/useClipboard';

interface Props {
  open: boolean;
  titulo: string;
  data: unknown;
  onClose: () => void;
}

function fmt(d: unknown): string {
  if (d == null) return '(vazio)';
  if (typeof d === 'string') {
    try {
      return JSON.stringify(JSON.parse(d), null, 2);
    } catch {
      return d;
    }
  }
  try {
    return JSON.stringify(d, null, 2);
  } catch {
    return String(d);
  }
}

export default function JsonViewerModal({ open, titulo, data, onClose }: Props) {
  const { copy, copied } = useClipboard();
  const [texto, setTexto] = useState('');

  useEffect(() => {
    if (open) setTexto(fmt(data));
  }, [open, data]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm dark:bg-black/70"
      onClick={onClose}
    >
      <div
        className="flex max-h-[88vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl dark:border-white/10 dark:bg-ink-900"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-white/10">
          <div className="flex items-center gap-2">
            <Braces className="h-5 w-5 text-sky-700 dark:text-sky-400" />
            <h3 className="font-semibold text-slate-950 dark:text-white">{titulo}</h3>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => copy(texto)}
              className="btn-secondary text-xs !py-1"
              title="Copiar conteúdo"
            >
              {copied ? <Check className="h-3.5 w-3.5 text-emerald-700 dark:text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
              {copied ? 'Copiado' : 'Copiar'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="btn-ghost !h-9 !w-9 !px-2 !py-1"
              aria-label="Fechar"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        <pre className="mono m-5 flex-1 overflow-auto whitespace-pre-wrap break-words rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700 dark:border-white/5 dark:bg-black/40 dark:text-neutral-200">
{texto}
        </pre>
      </div>
    </div>
  );
}
